import { ref } from 'vue';

export const currentLang = ref('en');

export function detectLang() {
  const lang = (navigator.languages?.[0] || navigator.language || 'en')
    .toLowerCase()
    .split('-')[0];
  return lang === 'fr' ? 'fr' : 'en';
}

const translations = {
  en: {
    welcomeTitle: 'Welcome to MyDid Bridge!',
    urlInvalid: 'URL is not valid.',
    checkingInfo: 'Checking information',
    importTitle: 'Import your badge',
    importSubtitle: "You're one click away from unlocking your {name} badge!",
    scanQR: 'Scan the QR Code to get the badge',
    getBadge: 'Get the badge',
    step1Title: '1. Scan QR Code',
    step1Desc:
      "If you already have the MyDID app, it will open by itself. Otherwise, you'll be guided to install it first.",
    step2Title: '2. Confirm',
    step2Desc: 'Import the badge into your wallet.',
    step3Title: '3. Done',
    step3Desc: 'Your new badge is now ready to use.',
    termsOfUse: 'Terms of use',
    privacyPolicy: 'Privacy Policy',
  },
  fr: {
    welcomeTitle: 'Bienvenue sur MyDid Bridge !',
    urlInvalid: "L'URL n'est pas valide.",
    checkingInfo: 'Vérification des informations',
    importTitle: 'Importer votre badge',
    importSubtitle: 'Vous êtes à un clic de débloquer votre badge {name} !',
    scanQR: 'Scannez le QR Code pour obtenir le badge',
    getBadge: 'Obtenir le badge',
    step1Title: '1. Scanner le QR Code',
    step1Desc:
      "Si vous avez déjà l'application MyDID, elle s'ouvrira d'elle-même. Sinon, vous serez guidé pour l'installer.",
    step2Title: '2. Confirmer',
    step2Desc: 'Importez le badge dans votre portefeuille.',
    step3Title: '3. Terminé',
    step3Desc: 'Votre nouveau badge est maintenant prêt à être utilisé.',
    termsOfUse: "Conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
  },
};

export function t(key, vars = {}) {
  const lang = currentLang.value;
  const dict = translations[lang] || translations.en;
  let str = dict[key] || translations.en[key] || key;
  Object.keys(vars).forEach((k) => {
    str = str.replace(`{${k}}`, vars[k]);
  });
  return str;
}
